import { Component, Input, OnInit, inject } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { PatientAttachmentListing } from '../../../core/models/patient-attachment-listing.model';
import { PatientAttachmentStatus } from '../../../core/enums/patient-attachment-status.enum';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { keyedPatientAttachmentStatusOptions } from '../../../core/options/patient-attachment-status.opts';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';
import { NgClass, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CopyToClipboardComponent } from '../../../shared/components/copy-to-clipboard/copy-to-clipboard.component';
import { PatientNameComponent } from '../../../shared/components/patient-name/patient-name.component';
import { ConsultNoteEstimatedValuesComponent } from '../../../shared/components/consult-note-estimated-values/consult-note-estimated-values.component';
import { ConsultNoteOfficeComponent } from '../../../shared/components/consult-note-office/consult-note-office.component';
import { BlankValueDashComponent } from '../../../shared/components/blank-value-dash/blank-value-dash.component';
import { ConsultNoteAssignedToComponent } from '../consult-note-assigned-to/consult-note-assigned-to.component';
import { JoinListPipe } from '../../../shared/pipes/join-list.pipe';

@Component({
  selector: 'app-consult-note-header',
  templateUrl: './consult-note-header.component.html',
  styleUrls: ['./consult-note-header.component.scss'],
  imports: [NgClass,
    RouterLink,
    CopyToClipboardComponent,
    PatientNameComponent,
    ConsultNoteEstimatedValuesComponent,
    ConsultNoteOfficeComponent,
    BlankValueDashComponent,
    ConsultNoteAssignedToComponent,
    DatePipe,
    JoinListPipe]
})
export class ConsultNoteHeaderComponent implements OnInit {
  private authService = inject(AuthenticationService);

  @Input() patientAttachment: PatientAttachment;

  canViewPatient = false;
  openRelatedAttachments: PatientAttachmentListing[];
  openRelatedAttachmentsCount: number;
  statusOptions = keyedPatientAttachmentStatusOptions;

  ngOnInit() {
    this.canViewPatient = this.authService.isCaptureAdminUser;
    this.handleOpenRelatedAttachments();
  }

  public get showHealthGorillaTag(): boolean {
    const clientEnabled = this.patientAttachment.client.healthGorillaSettings?.enabled;
    const userAllowed = this.authService.hasPermissionTo(UserRoleName.accessHieData);
    const patientHasData = !!this.patientAttachment.patient.healthGorillaIdentifier;

    return clientEnabled && userAllowed && patientHasData
  }

  handleOpenRelatedAttachments() {
    this.openRelatedAttachments = this.patientAttachment.relatedPatientAttachments.filter(
      (patientAttachmentListing: PatientAttachmentListing) =>
        patientAttachmentListing.status === PatientAttachmentStatus.open
    )
    this.openRelatedAttachmentsCount = this.openRelatedAttachments.length;
  }
}
